import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none" {...props}>
    <path
      fill="#fff"
      d="m16.956 31.329 2.428-14.532h3.882l-2.43 14.532h-3.88Zm17.91-14.219c-.77-.295-1.976-.61-3.482-.61-3.837 0-6.538 1.971-6.562 4.796-.021 2.088 1.93 3.252 3.403 3.948 1.51.713 2.02 1.166 2.012 1.803-.01.971-1.208 1.417-2.324 1.417-1.554 0-2.379-.219-3.655-.762l-.5-.231-.544 3.252c.906.407 2.584.759 4.324.777 4.082 0 6.732-1.948 6.762-4.966.015-1.653-1.02-2.91-3.26-3.948-1.357-.672-2.188-1.121-2.179-1.802 0-.604.704-1.25 2.223-1.25a7.06 7.06 0 0 1 2.907.557l.348.168.527-3.149Zm9.991-.313h-3c-.93 0-1.624.26-2.032 1.206l-5.768 13.316h4.077s.666-1.79.818-2.183l4.972.006c.116.51.473 2.177.473 2.177H48l-3.143-14.522Zm-4.76 9.383c.32-.837 1.546-4.063 1.546-4.063-.023.04.318-.841.514-1.387l.263 1.253s.744 3.469.898 4.195l-3.222.002Zm-26.438-9.383-3.801 9.91-.405-2.014c-.708-2.322-2.913-4.838-5.378-6.096l3.476 12.708 4.108-.005 6.114-14.503H13.66Z"
    />
    <path
      fill="#fff"
      d="M6.31 16.797H.05l-.05.301c4.872 1.203 8.094 4.11 9.432 7.604l-1.36-6.678c-.236-.921-.917-1.196-1.761-1.227Z"
    />
  </svg>
);
export { SvgComponent as Visa };
